import checkIsTicketTypeSoldOut from './checkIsTicketTypeSoldOut';

/**
 * Checks if a ticket group is sold out based on various conditions
 * @param {Object} ticketGroup - The ticket group object to check
 * @returns {boolean} - True if ticket group is sold out, false otherwise
 */
export default function checkIsTicketGroupSoldOut(
  ticketGroup,
  options = { excludeTicketTypes: false },
) {
  if (!ticketGroup) return false;
  const { excludeTicketTypes } = options;

  if (excludeTicketTypes) {
    return (
      ticketGroup.isSoldOut === true ||
      ticketGroup.availabilityStatus === 'sold_out' ||
      (ticketGroup.capacity !== null &&
        ticketGroup.capacity !== undefined &&
        ticketGroup.quantitySold >= ticketGroup.capacity)
    );
  }

  return (
    ticketGroup.isSoldOut === true ||
    (ticketGroup.ticketTypes.length > 0 &&
      ticketGroup.ticketTypes.every(t => checkIsTicketTypeSoldOut(t))) ||
    ticketGroup.availabilityStatus === 'sold_out' ||
    (ticketGroup.capacity !== null &&
      ticketGroup.capacity !== undefined &&
      ticketGroup.quantitySold >= ticketGroup.capacity)
  );
}
